import { render, staticRenderFns } from "./ZoomImages2.vue?vue&type=template&id=27a37a86&"
import script from "./ZoomImages2.vue?vue&type=script&lang=js&"
export * from "./ZoomImages2.vue?vue&type=script&lang=js&"
import style0 from "./ZoomImages2.vue?vue&type=style&index=0&id=27a37a86&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports